/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

function getPadding(ratio) {
  const arr = ratio.split(':');
  const width = Number(arr[0]);
  const height = Number(arr[1]);
  const padding = (height * 100) / width;
  return `${padding}%`;
}

export default class ModalVideo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.closeModal = this.closeModal.bind(this);
    this.updateFocus = this.updateFocus.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ isOpen: nextProps.isOpen });
  }

  componentDidUpdate() {
    if (this.state.isOpen) {
      this.modal.focus();
    }
  }

  openModal() {
    this.setState({ isOpen: true });
  }

  closeModal() {
    this.setState({ isOpen: false });
    if (typeof this.props.onClose === 'function') {
      this.props.onClose();
    }
  }

  updateFocus(e) {
    if (e.keyCode === 9) {
      e.preventDefault();
      e.stopPropagation();
      if (this.modal === document.activeElement) {
        this.modalbtn.focus();
      } else {
        this.modal.focus();
      }
    }
  }

  render() {
    const style = {
      paddingBottom: getPadding(this.props.ratio),
    };

    return (
      <ReactCSSTransitionGroup
        transitionName={this.props.classNames.modalVideoEffect}
        transitionEnterTimeout={this.props.animationSpeed}
        transitionLeaveTimeout={this.props.animationSpeed}
      >
        {(() => {
          if (this.state.isOpen) {
            return (
              <div
                className={this.props.classNames.modalVideo}
                tabIndex="-1"
                role="dialog"
                aria-label={this.props.aria.openMessage}
                onClick={this.closeModal}
                ref={(node) => { this.modal = node; }}
                onKeyDown={this.updateFocus}
              >
                <div className={this.props.classNames.modalVideoBody}>
                  <div className={this.props.classNames.modalVideoInner}>
                    <div className={this.props.classNames.modalVideoIframeWrap} style={style}>
                      <button
                        className={this.props.classNames.modalVideoCloseBtn}
                        aria-label={this.props.aria.dismissBtnMessage}
                        ref={(node) => { this.modalbtn = node; }}
                        onKeyDown={this.updateFocus}
                      />
                      <div width="460" height="230">
                        <video controls autoPlay loop style={{ width: '100%' }}>
                          <source src={this.props.videoUrl} type="video/mp4" />
                        </video>
                      </div>
                    </div>
                  </div>
                </div>
              </div>);
          }
        })()}
      </ReactCSSTransitionGroup>
    );
  }
}

ModalVideo.defaultProps = {
  videoUrl: null,
  isOpen: false,
  onClose: null,
  ratio: '16:9',
  animationSpeed: 300,
  classNames: {
    modalVideoEffect: 'modal-video-effect',
    modalVideo: 'modal-video',
    modalVideoClose: 'modal-video-close',
    modalVideoBody: 'modal-video-body',
    modalVideoInner: 'modal-video-inner',
    modalVideoIframeWrap: 'modal-video-movie-wrap',
    modalVideoCloseBtn: 'modal-video-close-btn',
  },
  aria: {
    openMessage: 'You just openned the modal video',
    dismissBtnMessage: 'Close the modal by clicking here',
  },
};

ModalVideo.propTypes = {
  videoUrl: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  ratio: PropTypes.string,
  animationSpeed: PropTypes.number,
  classNames: PropTypes.object,
  aria: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/client/components/gallery/ModalVideo.js